import React, { useEffect, useState } from 'react';
import { Grid, Button, Modal, Typography } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { Tutorial } from '@pages/home/components';

interface IBanner {
    bannerAppDesk: string;
    bannerAppMob: string;
}

interface IHighlightBannersProps {
    imageURL: IBanner;
    destinationLink: string;
    isModal: boolean;
    imageTitle: string;
}

export const HighlightBanners: React.FC<IHighlightBannersProps> = ({ imageURL, destinationLink, isModal, imageTitle }) => {
    const [isMobile, setIsMobile] = useState(false);

    const [open, setOpen] = useState(false);
    const [selectedContent, setSelectedContent] = useState(null);

    const handleOpen = (content: any) => {
        setSelectedContent(content);
        setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const goTo = (content: any) => {
        let url =
            content === 'android' ? 'https://play.google.com/store/apps/details?id=br.com.calcard.android.app&hl=pt_BR&gl=US&pli=1' : 'https://apps.apple.com/br/app/ouze-cart%C3%A3o/id1449138029';
        window.open(url, '_blank');
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const imgStyleMob = {
        width: 'calc(100% + 32px)',
        marginLeft: '-16px',
        marginRight: '-16px'
    };
    const imgStyleDesk = {
        width: '100%'
    };
    const modalStyle = {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '95%',
        width: '90%',
        maxWidth: '1080px',
        overflowY: 'auto' as const,
        position: 'absolute' as const,
        backgroundColor: 'white',
        borderRadius: '8px',
        outline: 'none'
    };

    return (
        <>
            {!isModal && destinationLink !== '' ? (
                <a href={destinationLink}>
                    <img
                        srcSet={isMobile ? imageURL.bannerAppMob : imageURL.bannerAppDesk}
                        src={isMobile ? imageURL.bannerAppMob : imageURL.bannerAppDesk}
                        alt={imageTitle}
                        loading="lazy"
                        style={isMobile ? imgStyleMob : imgStyleDesk}
                    />
                </a>
            ) : (
                <img
                    srcSet={isMobile ? imageURL.bannerAppMob : imageURL.bannerAppDesk}
                    src={isMobile ? imageURL.bannerAppMob : imageURL.bannerAppDesk}
                    alt={imageTitle}
                    loading="lazy"
                    style={isMobile ? imgStyleMob : imgStyleDesk}
                />
            )}
            <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                <Button onClick={() => goTo('iphone')} sx={{ width: '150px', background: '#E400E4', color: '#fff' }}>
                    Usuário Iphone
                </Button>
                <Button onClick={() => goTo('android')} sx={{ width: '150px', background: '#E400E4', color: '#fff' }}>
                    Usuário Android
                </Button>
            </Grid>
            {isModal && (
                <>
                    <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                        <Button onClick={() => handleOpen('iphone')} sx={{ width: '150px', background: '#E400E4', color: '#fff' }}>
                            Usuário Iphone
                        </Button>
                        <Button onClick={() => handleOpen('android')} sx={{ width: '150px', background: '#E400E4', color: '#fff' }}>
                            Usuário Android
                        </Button>
                    </Grid>
                    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <>
                            <Button sx={{ top: '2%', right: '1%', position: 'absolute', zIndex: 1 }} onClick={handleClose}>
                                <Typography
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        background: 'rgba(255,255,255,.5)',
                                        borderRadius: '5px',
                                        fontSize: '20px',
                                        lineHeight: 0,
                                        width: '30px',
                                        height: '30px'
                                    }}
                                >
                                    <CloseOutlined />
                                </Typography>
                            </Button>
                            <div style={modalStyle}>
                                <Tutorial contentType={selectedContent} isMobile={isMobile} />
                            </div>
                        </>
                    </Modal>
                </>
            )}
        </>
    );
};
